import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const KpiLineChart = ({ data, title, color = '#007bff' }) => {
  // Format the data to match preview styling
  const formattedData = {
    ...data,
    datasets: data.datasets?.map(dataset => ({
      ...dataset,
      backgroundColor: dataset.backgroundColor || (dataset.seriesColor ? dataset.seriesColor + '20' : color + '20'), // Add transparency
      borderColor: dataset.borderColor || dataset.seriesColor || color,
      borderWidth: dataset.borderWidth || 2,
      fill: dataset.fill || false,
    })) || []
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: !!title,
        text: title,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <div style={{ height: '300px', width: '100%' }}>
      <Line data={formattedData} options={options} />
    </div>
  );
};

export default KpiLineChart;
